window.$ = window.jQuery = require('jquery');
import * as cookies from "./utils/cookies.js";

export function setAlertBar() {
    $(document).ready(function () {
        let alertBar = document.getElementById("alertBar");
        if (alertBar) {
            var learnMoreBtn = document.getElementById("learnMore");
            if(learnMoreBtn){
                learnMoreBtn.addEventListener("click", closeAlertBar);
            }

            var mobileLearnMore = document.getElementById("mobile-learnMore");
            if(mobileLearnMore){
                mobileLearnMore.addEventListener("click", closeAlertBar);
            }
            document.getElementById("closeAlertBar").addEventListener("click", closeAlertBar);
        }
    });
}

function closeAlertBar() {
    document.getElementById("alertBar").style.display = "none";
    var alertBarCookie = cookies.getCookie("ALERTBAR");
    if (!alertBarCookie || alertBarCookie == ""){
        cookies.setCookie("ALERTBAR", "1", 1);
    }
}


// WEBPACK FOOTER //
// ./resources/js/alertBar.js